import { ListAlt } from "@mui/icons-material";
import { useSessionContext } from "@/contexts/SessionContext";
import type { IFeatures } from "@/utils/interfaces";
import { QuestionnaireRespondPage } from "./QuestionnaireRespondPage";

export function useQuestionnaireRespondPage() {
  const { access } = useSessionContext();

  const configs: IFeatures = {
    initial: false,
    active: access?.type === "patient",
    path: "/questionnaire-respond",
    icon: ListAlt,
    text: "Responder questionário",
    sideMenu: false,
    avatarMenu: false,
    component: () => <QuestionnaireRespondPage />,
  };

  return configs;
}

